import { queryOptions } from '@tanstack/react-query';
import { getDocumentServiceSchemaClient } from 'services/api/client';
import { QueryKeys } from 'utils/queryKeys';
import { trackError } from '@proposify/frontend-observability';
import { DocumentServiceFoldersRepository } from 'services/folders/DocumentServiceFoldersRepository';
import { documentServiceClient, ContentControllerFindQueryParamsTypeEnum } from '@proposify/document-service-api-schema';

type Image = { id: string; name: string; content: string };

async function fetchImages(): Promise<Image[]> {
  const response = await documentServiceClient.contentFind(
    { type: ContentControllerFindQueryParamsTypeEnum.IMAGE },
    getDocumentServiceSchemaClient()
  );

  return response.reduce<Image[]>((acc, asset) => {
    if ('imageUrl' in asset.data && typeof asset.data.imageUrl === 'string') {
      acc.push({ id: asset.id, name: asset.name, content: asset.data.imageUrl });
    }
    return acc;
  }, []);
}

const list = queryOptions({
  queryKey: QueryKeys.contentLibraryImages,
  queryFn: fetchImages,
  throwOnError: (error: Error) => {
    trackError(error);
    return false;
  },
});

const listFolders = queryOptions({
  queryKey: QueryKeys.contentLibraryImagesFolders,
  queryFn: async () => await DocumentServiceFoldersRepository.listFolders({ type: 'IMAGE' }),
});

const getById = (id: string) =>
  queryOptions({
    ...list,
    notifyOnChangeProps: ['data'],
    select: (data) => {
      const image = data.find((image) => image.id === id);
      if (!image) return undefined;
      return image;
    },
  });

export const imagesQueries = {
  list,
  listFolders,
  getById,
};
